import React, { Children } from 'react'

import { Row, Col, Button, Table, InputNumber } from 'antd'
import { render } from '@testing-library/react'

import { saveMetrics } from '../../helpers/meetings/saveMetrics'

const Metrics = ({ dataMetrics, dataMetricsEdit, setDataMetricsEdit, setLoadDataMetrics, quarterly, meetingDate, setShowAlertMetrics, setOptionAlert }) => {
    const handleSaveMetrics = () => {
        saveMetrics(dataMetricsEdit, quarterly, meetingDate).then((response) => {
            if (response.status === "success") {
                setShowAlertMetrics(true);
                setOptionAlert({
                    message: "Métricas actualizadas",
                    description: "Las métricas se han actualizado correctamente.",
                    type: "success"
                });
                setDataMetricsEdit([]);
                setLoadDataMetrics(true);
            }
        });
    }

    const editMetrics = (value, record, week) => {
        const updatedMetrics = dataMetrics
            .filter(metric => metric.id === record.id && metric.brand === record.brand)
            .map(metric => ({ id: metric.id, brand: record.brand, value, week_updated: week }));

        setDataMetricsEdit(prev =>
            [
                ...prev.filter(p => p.id !== record.id || p.brand !== record.brand || p.week_updated !== week),
                ...updatedMetrics
            ]
        );
    }

    const columns = [
        {
            title: 'MARCA',
            dataIndex: 'brand',
            key: 'brand',
            width: 50,
        },
        {
            title: 'Metrica',
            dataIndex: 'metric',
            key: 'metric',
            width: 50,
        },
        {
            title: '01 al 06 de Julio',
            dataIndex: 'week1',
            key: 'week1',
            width: 50,
            render: (_, record) => {
                const value = record.week1;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week1')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week1')} />;
            },
        },
        {
            title: '7 al 13 de Julio',
            dataIndex: 'week2',
            key: 'week2',
            width: 50,
            render: (_, record) => {
                const value = record.week2;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week2')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week2')} />;
            },
        },
        {
            title: '14 al 20 de Julio',
            dataIndex: 'week3',
            key: 'week3',
            width: 50,
            render: (_, record) => {
                const value = record.week3;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week3')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week3')} />;
            },
        },
        {
            title: '21 al 27 de Julio',
            dataIndex: 'week4',
            key: 'week4',
            width: 50,
            render: (_, record) => {
                const value = record.week4;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week4')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week4')} />;
            },
        },
        {
            title: '28 al 31 de Julio',
            dataIndex: 'week5',
            key: 'week5',
            width: 50,
            render: (_, record) => {
                const value = record.week5;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week5')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week5')} />;
            },
        },
        {
            title: '',
            dataIndex: 'space1',
            key: 'space1',
            width: 50,
            render: (_, record) => {
                let total = 0;

                for (let i = 1; i <= 5; i++) {
                    total += record[`week${i}`] || 0;
                }

                return <p style={{ fontWeight: 'bold' }}>{total}</p>
            }
        },
        {
            title: '1 al 3 de Agosto',
            dataIndex: 'week6',
            key: 'week6',
            width: 50,
            render: (_, record) => {
                const value = record.week6;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week6')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week6')} />;
            },
        },
        {
            title: '4 al 10 de Agosto',
            dataIndex: 'week7',
            key: 'week7',
            width: 50,
            render: (_, record) => {
                const value = record.week7;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week7')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week7')} />;
            },
        },
        {
            title: '11 al 17 de Agosto',
            dataIndex: 'week8',
            key: 'week8',
            width: 50,
            render: (_, record) => {
                const value = record.week8;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week8')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week8')} />;
            },
        },
        {
            title: '18 al 24 de Agosto',
            dataIndex: 'week9',
            key: 'week9',
            width: 50,
            render: (_, record) => {
                const value = record.week9;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week9')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week9')} />;
            },
        },
        {
            title: '25 al 31 de Agosto',
            dataIndex: 'week10',
            key: 'week10',
            width: 50,
            render: (_, record) => {
                const value = record.week10;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week10')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week10')} />;
            },
        },
        {
            title: '',
            dataIndex: 'space2',
            key: 'space2',
            width: 50,
            render: (_, record) => {
                let total = 0;

                for (let i = 6; i <= 10; i++) {
                    total += record[`week${i}`] || 0;
                }

                return <p style={{ fontWeight: 'bold' }}>{total}</p>
            }
        },
        {
            title: '1 al 7 de Septiembre',
            dataIndex: 'week11',
            key: 'week11',
            width: 50,
            render: (_, record) => {
                const value = record.week11;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week11')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week11')} />;
            },
        },
        {
            title: '8 al 14 de Septiembre',
            dataIndex: 'week12',
            key: 'week12',
            width: 50,
            render: (_, record) => {
                const value = record.week12;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week12')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week12')} />;
            },
        },
        {
            title: '15 al 21 de Septiembre',
            dataIndex: 'week13',
            key: 'week13',
            width: 50,
            render: (_, record) => {
                const value = record.week13;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week13')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week13')} />;
            },
        },
        {
            title: '22 al 28 de Septiembre',
            dataIndex: 'week14',
            key: 'week14',
            width: 50,
            render: (_, record) => {
                const value = record.week14;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week14')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week14')} />;
            },
        },
        {
            title: '29 al 30 de Septiembre',
            dataIndex: 'week15',
            key: 'week15',
            width: 50,
            render: (_, record) => {
                const value = record.week15;
                return <InputNumber style={{ width: 50 }} value={dataMetricsEdit.find(o => o.brand === record.brand && o.id === record.id && o.week_updated === 'week15')?.value ??
                    value} onChange={value => editMetrics(value, record, 'week15')} />;
            },
        },
        {
            title: '',
            dataIndex: 'space3',
            key: 'space3',
            width: 50,
            render: (_, record) => {
                let total = 0;

                for (let i = 11; i <= 15; i++) {
                    total += record[`week${i}`] || 0;
                }

                return <p style={{ fontWeight: 'bold' }}>{total}</p>
            }
        },
        {
            title: 'Total trimestre',
            dataIndex: 'total',
            key: 'total',
            width: 50,
            render: (text, record) => {
                const total = Object.keys(record)
                    .filter(key =>  /^week([1-9]|1[0-5])$/.test(key))
                    .reduce((acc, key) => acc + (record[key] ?? 0), 0);
                return <p style={{ width: 50, fontWeight: 'bold' }}>{total}</p>;
            }
        },
    ]

    return (
        <div style={{ margin: "0 12px" }}>
            <Row style={{ marginBottom: 16 }} gutter={16}>
                <Col span={12}>
                    <h3 style={{ fontSize: "18px", margin: 0 }}>Métricas 3er Trimestre | Grupo Optima</h3>
                    <p style={{ fontSize: "16px", margin: 0, color: "gray" }}>Junio - Septiembre 2025</p>
                </Col>
                <Col span={12} style={{ textAlign: "right", justifyContent: "flex-end", display: "flex" }}>
                    <Row span={24} gutter={16}>
                        <Col span={12}>
                            <Button type="primary" style={{ backgroundColor: '#00A310', border: 'none' }} onClick={handleSaveMetrics}>Guarda métricas</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Table dataSource={dataMetrics} columns={columns} pagination={false} />
                </Col>
            </Row>
        </div>
    )
}

export default Metrics